import React from "react";
import { getStatusInfo } from "./jobStatusMaps";
import "./jobStatusBadge.css";

/**
 * Status pill shared across the Jobs list, Job Detail cards and the JobCalendar
 * popover, backed by jobStatusMaps.
 *
 * `count` is only meaningful for the email domain, which prefixes the label
 * with it ("2 Ready to Send").
 */
const JobStatusBadge = ({
  domain,
  value,
  count,
  emptyText = "—",
  className = "",
}) => {
  const info = getStatusInfo(domain, value);

  if (!info) {
    return (
      <span
        className={`job-status-badge job-status-badge--empty ${className}`.trim()}
      >
        {emptyText}
      </span>
    );
  }

  return (
    <span
      className={`job-status-badge job-status-badge--${info.tone} ${className}`.trim()}
    >
      {count != null ? `${count} ${info.label}` : info.label}
    </span>
  );
};

export default JobStatusBadge;
